import React from 'react'

import { Card, Col, Row, Container } from 'reactstrap'

import upwork from '../assets/img/icons/common/upwork.png'
import avatar from '../assets/img/avatar.jpg'
import { contact, socialLinks } from '../portfolio'

import SocialLinks from '../components/SocialLinks'

const GithubProfileCard = ({ prof = {} }) => {
  const photo = prof.avatar_url || avatar
  const location = prof.location || contact.location
  const bio = prof.bio || contact.bio

  return (
    <Card className="section-lg bg-gradient-info shadow-lg border-0">
      <Container className="">
        <div className="p-2">
          <Row className="align-items-center">
            <Col className="order-lg-2" lg="4">
              <img
                src={photo}
                style={{ width: '200px' }}
                alt="phileba"
                className="rounded-circle img-center img-fluid shadow shadow-lg--hover mb-4"
              />
            </Col>
            <Col lg="8" className="order-lg-1">
              <h2 className="text-white">
                Reach out to me via
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={socialLinks.upwork}
                >
                  <img src={upwork} alt="Upwork" style={{ width: '50px' }} />
                </a>
              </h2>

              {bio ? <p className="text-white mt-3">{bio}</p> : null}
              {location ? (
                <div className="my-3 icon-shape bg-gradient-white shadow rounded text-info">
                  <i className="ni ni-pin-3 text-info mr-2" />
                  {location}
                </div>
              ) : null}
              <SocialLinks />
            </Col>
          </Row>
        </div>
      </Container>
    </Card>
  )
}

export default GithubProfileCard
